<div class="sidebar" role="dialog">

	<app-sidebar-header [title]="'extrasSidebar.findHotels.title.hotelFilter' | ibeadmin | async">
		<div actions><button class="button button--small" (click)="INDRA_applyFilters()" aria-label="Confirm changes">{{ 'extrasSidebar.findHotels.button.apply' | ibeadmin | async }}</button></div>
	</app-sidebar-header>

	<div class="sidebar__body sl--scrollable low-contrast sidebar-wrapper" #sidebar__body>
			<div class="grid no-padding">
				<div class="col-6 col-tp-6 col-p-6">
					<app-select-input
						[id]="'flights-filter-prive'"
						[label]="'extrasSidebar.findHotels.text.pricePerNight' | ibeadmin | async"
						[placeholder]="'extrasSidebar.findHotels.text.selectPriceRange' | ibeadmin | async"
						[inputOptions]="optionsPrice"
						[inputValue]="selectedPrice"
						[(ngModel)]="selectedPrice"></app-select-input>
				</div>

				<div class="col-6 col-tp-6 col-p-6">
					<app-select-input
						[id]="'flights-filter-stars'"
						[label]="'extrasSidebar.findHotels.text.stars' | ibeadmin | async"
						[placeholder]="'extrasSidebar.findHotels.text.selectStars' | ibeadmin | async"
						[inputOptions]="optionsStars"
						[inputValue]="selectedStars"
						[(ngModel)]="selectedStars"></app-select-input>
				</div>
			</div>

			<h2 class="title-h2">{{ 'extrasSidebar.findHotels.text.propertyType' | ibeadmin | async }}</h2>

			<div class="grid no-padding" tabindex="0" [attr.aria-label]="'extrasSidebar.findHotels.aria.selectPropertySection' | ibeadmin | async">
				<div class="col-6 col-tp-6 col-p-6" *ngFor="let property of propertyFilter; let i = index">
					<label class="checkbox-wrapper" role="radio" [attr.for]="property.key">
						<input [attr.id]="property.key" [(ngModel)]="property.checked" type="checkbox" autocomplete="false" class="checkbox">
						<span [ngClass]="{'align-right': align_right}"><label [attr.for]="property.key">{{ property.label }}</label></span>
					</label>
				</div>
			</div>

			<h2 class="title-h2">{{ 'extrasSidebar.findHotels.text.facilities' | ibeadmin | async }}</h2>

			<div class="grid no-padding" tabindex="0" [attr.aria-label]="'extrasSidebar.findHotels.aria.selectFacilitiesSection' | ibeadmin | async">
				<div class="ol-6 col-tp-6 col-p-6" *ngFor="let facilities of facilitiesFilter; let i = index">
					<label class="checkbox-wrapper" role="radio" [attr.for]="facilities.key">
						<input [attr.id]="facilities.key" [(ngModel)]="facilities.checked" type="checkbox" autocomplete="false" class="checkbox">
						<span [ngClass]="{'align-right': align_right}"><label [attr.for]="facilities.key">{{ facilities.label }}</label></span>
					</label>
				</div>
			</div>

			<button class="button full-width" type="submit" (click)="INDRA_applyFilters()" [attr.aria-label]="'extrasSidebar.findHotels.aria.applyFiltersInHotel' | ibeadmin | async">
				{{ 'extrasSidebar.findHotels.button.applyFilters' | ibeadmin | async }}
			</button>
	</div>
</div>
